<template>
  <div class="security">
    <title-bar-back :title="'修改手机号'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 新手机号 -->
    <new-phone @changePhone="changePhone" />
    <!-- 验证码 -->
    <code-field :phone="newPhone" @input="input" />
    <!-- button -->
    <div
      :class="verifyCode.length === 6 ? 'go_btn' : 'un_btn'"
      class="font14 font_weight500 colof btn"
      @click="goNext"
    >
      确定
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const NewPhone = () =>
  import("./components/NewPhone").then(m => m.default || m);
const CodeField = () =>
  import("./components/CodeField").then(m => m.default || m);
export default {
  name: "ModifyPhone",
  components: {
    TitleBarBack,
    CodeField,
    NewPhone
  },
  data() {
    return {
      verifyCode: "",
      newPhone: ""
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    input(value) {
      this.verifyCode = value;
    },
    changePhone(value) {
      this.newPhone = value;
    },
    goNext() {
      if (this.verifyCode.length < 6) {
        this.$toast("请输入验证码");
        return;
      }
      // changePhone
      const params = {
        phone: this.newPhone.trim(),
        code: this.verifyCode.trim(),
        kind: "changePhone"
      };
      this.$store
        .dispatch("mine/changePhone", { params })
        .then(() => {
          this.$toast("手机号设置成功");
          setTimeout(() => {
            this.$router.go(-2);
          }, 500);
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.security {
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .btn {
    margin: 16px 12px 0;
    line-height: 40px;
    border-radius: 20px;
  }
  .un_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    opacity: 0.5;
  }
  .go_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  }
}
</style>
